const _ = require('underscore');

class EditAssetForm {
  static initClass() {
    this.prototype.fieldErrorTemplate = _.template(
      "<span class='error'><%- message %></span>",
    );
  }

  constructor() {
    this.$form = $('form#form-for-asset');
    this.$form.submit((event) => {
      this.clearErrors();

      let fieldsToCheck = window.alwaysRequiredFields;
      if (fieldsToCheck === undefined) {
        fieldsToCheck = [];
      }

      if (this.needsRequiredFields()) {
        if (window.requiredFields !== undefined) {
          fieldsToCheck = fieldsToCheck.concat(window.requiredFields);
        }
      }

      let foundErrors = false;

      const uniqueFields = $.unique(fieldsToCheck);

      for (var field of uniqueFields) {
        var $field = this.$form.find(field);
        if (
          $field.prop('type') === 'checkbox' &&
          $field.prop('checked') === false
        ) {
          foundErrors = true;
          this.showErrorForField($field, 'must be checked');
        } else if ($field.prop('type') === 'file') {
          var $imagePreview = $field
            .parent()
            .parent()
            .parent()
            .find('.image-area__preview')
            .children();
          if ($imagePreview.length === 0) {
            foundErrors = true;
            this.showErrorForField($field, 'must add file');
          } else {
            if ($imagePreview.find('input[type=checkbox]').is(':checked')) {
              foundErrors = true;
              this.showErrorForField($field, 'cannot remove required file');
            }
          }
        } else if ($field.val() === '') {
          foundErrors = true;
          this.showErrorForField($field, "can't be blank");
        }
      }

      if (foundErrors) {
        this.scrollToFirstError();
        event.stopImmediatePropagation();
        return event.preventDefault();
      }
    });
  }

  showErrorForField($field, message) {
    const $fieldWrapper = $field.closest('div.input');

    $fieldWrapper.addClass('field_with_errors');
    return $fieldWrapper.append($(this.fieldErrorTemplate({ message })));
  }

  clearErrors() {
    $('.error').remove();
    return Array.from($('.field_with_errors')).map((field) =>
      $(field).removeClass('field_with_errors'),
    );
  }

  needsRequiredFields() {
    const surveyState = this.$form.find('#asset_status').val();

    if (surveyState.toLowerCase() === 'complete') {
      return true;
    }
    return false;
  }

  scrollToFirstError() {
    const $errorFields = $('.field_with_errors');
    if ($errorFields.length > 0) {
      return $('html, body').animate(
        {
          scrollTop: $errorFields.first().offset().top,
        },
        500,
      );
    }
  }
}
EditAssetForm.initClass();

// --
module.exports = EditAssetForm;
